var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMileageTrackerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 509.36 509.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 254.68,
    y1: 510.79,
    x2: 254.68,
    y2: -0.08,
    gradientTransform: "translate(0 510.07) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0780af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d6183"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 509.36,
    height: 509.36,
    rx: 54.11,
    ry: 54.11,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 282.5,
    width: 1.49,
    height: 0.99,
    style: {
      fill: "#0b7ba5"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M254.68,399.44c-79.77,0-144.67-64.94-144.67-144.76S174.91,109.92,254.68,109.92s144.67,64.94,144.67,144.76-64.9,144.76-144.67,144.76ZM254.68,94.59c-88.22,0-160,71.82-160,160.09s71.78,160.09,160,160.09,160-71.82,160-160.09-71.77-160.09-160-160.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.63,195.29l-41.12,53.84c1.37,7.91-1.15,16.05-6.9,21.81-4.84,4.84-11.19,7.26-17.55,7.26s-12.71-2.42-17.55-7.26c-9.68-9.68-9.68-25.43,0-35.12,5.55-5.55,13.45-8.11,21.16-6.99l54.47-41.09c2.14-1.61,5.15-1.4,7.04.5,1.89,1.9,2.08,4.91.46,7.04ZM254.68,135.86c-65.97,0-119.64,53.7-119.64,119.71s53.67,119.71,119.64,119.71,119.64-53.7,119.64-119.71-53.67-119.71-119.64-119.71Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileageTrackerIcon);
export default __webpack_public_path__ + "static/media/mileage-tracker-icon.ebea150864923723ad3ddc185265057e.svg";
export { ForwardRef as ReactComponent };